import React from "react";
import { Col, Row } from "react-bootstrap";
import IconSvg from "../../../../../../SharedComponents/IconSvg";

export default function MonoText({ item, isSub, isForHeightCalculation }) {
  const hitRange = isForHeightCalculation
    ? item.scale.ranges[0]
    : item.scale.ranges.find((range) => range.start <= Number(item.score) && Number(item.score) <= range.end);

  return (
    <Row className={(!hitRange && "d-none") + " mb-3"} style={{ height: Number(item?.height), marginBottom: "6px" }}>
      <Col>
        <div className={"round-40px p-2 "} style={{ backgroundColor: "#efefef" }}>
          <div className={"position-relative "}>
            <div className={"position-absolute"} style={{ top: -20, left: -4 }}>
              <IconSvg icon={"documentIcon"} height={30} width={30} />
            </div>

            <Row>
              <Col>
                <div className={"round-40px p-2"} style={{ backgroundColor: "#ffffff", fontSize: 12 }}>
                  {item.scale?.isHtml ? <div dangerouslySetInnerHTML={{ __html: hitRange?.text }} /> : hitRange?.text}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </Row>
  );
}
